import { c as _c } from "react/compiler-runtime";
import { useCanAssignProjectRoles } from "@hooks/feature-control/use-can-assign-project-roles";
import { useHasUserValidPermissionProjectLevel } from "@hooks/permission-control/use-has-user-valid-permission-project-level";
import { UtilsTypes } from "@stellar/utils";
import { getProjectArchivingState, isProjectDemo } from "@utils/project-utils";
/**
 * Returns what the current user may do with the members of a project. The role column, the share
 * dialog and the 3-dot menu all ask here, so that they offer the same actions.
 *
 * Both need the matching project permission, held by project admins, the managers of the
 * project's group and workspace admins, and an active project that is not a demo. The owner can
 * neither be reassigned nor removed.
 *
 * @param project The project, or nothing while it is not loaded
 */
export function useProjectMemberActions(project) {
  const $ = _c(12);
  const t0 = project ?? null;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      project: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    canChangeRole,
    canDeleteMemberFromProject
  } = useHasUserValidPermissionProjectLevel(t1);
  const canAssignProjectRoles = useCanAssignProjectRoles();
  let t2;
  if ($[2] !== project) {
    t2 = !!project && getProjectArchivingState(project.archivingState) === UtilsTypes.ProjectArchivingState.active && !isProjectDemo(project);
    $[2] = project;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isProjectActive = t2;
  const canChangeRoles = isProjectActive && canChangeRole && canAssignProjectRoles;
  const canRemoveMembers = isProjectActive && canDeleteMemberFromProject;
  let t3;
  if ($[4] !== canChangeRoles) {
    t3 = member => canChangeRoles && member.role !== "RESOURCE_OWNER";
    $[4] = canChangeRoles;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== canRemoveMembers) {
    t4 = member_0 => canRemoveMembers && member_0.role !== "RESOURCE_OWNER";
    $[6] = canRemoveMembers;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== canRemoveMembers || $[9] !== t3 || $[10] !== t4) {
    t5 = {
      canRemoveMembers,
      canChangeRole: t3,
      canRemove: t4
    };
    $[8] = canRemoveMembers;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}